export default __webpack_public_path__ + "d9355285dfd492931492bf06ea6819d9.jpg";